<template>
  <b-card class="p-0 well-card">
    <div v-if="well" class="well-card-content" :class="size" @click="goToWell">
      <synchronized-well-video
          v-if="!isMobile"
          :well="well"
          :quality="size === 'large' ? 'high' : 'low'"
          :master="master"
          :class="size"
      />

      <well-preview-image v-else class="m-1 mr-2" :well="well"/>

      <!--            <annotation-hazard v-if="!isFdaFriendly" :well="well" />-->

      <well-card-details :well="well" :size="size"/>
    </div>

    <well-card-ghost v-else/>
  </b-card>
</template>

<script>
import {mapGetters} from 'vuex'
import Utils from '../../business/utils/Utils'
import SynchronizedWellVideo from './SynchronizedWellVideo'
import WellPreviewImage from './WellPreviewImage'
import AnnotationHazard from './common/AnnotationHazard'
import WellCardGhost from './partials/WellCardGhost'
import WellCardDetails from './partials/WellCardDetails'

export default {
  name: 'WellCard',
  components: {
    WellCardDetails,
    WellCardGhost,
    AnnotationHazard,
    WellPreviewImage,
    SynchronizedWellVideo
  },
  props: {
    well: {
      type: Object,
      default: null
    },
    master: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    ...mapGetters({
      isFdaFriendly: 'common/isFdaFriendly'
    }),
    isMobile() {
      return Utils.isMobileSize()
    }
  },
  methods: {
    goToWell() {
      this.$mainController.selectWell(this.well)
    }
  }
}
</script>

<style lang="scss">
.well-card {
  width: auto;
  background: transparent;
  @include prevent-select();

  .card-body {
    padding: 0;
    display: flex;
    border: none !important;
  }

  .annotation-hazard {
    position: absolute;
    bottom: 1.5rem;
    left: 1rem;
    width: 2rem;
    margin-right: 1rem;

    .hazard-icon {
      height: 1.3rem;
      margin-top: 0.1rem;
    }
  }

  .well-card-content {
    position: relative;
    width: 100%;
    padding: 6px;
    display: flex;
    border-radius: $border-radius;
    transition: all 0.3s, border 0s;
    background-color: $dark-3;
    cursor: pointer;

    .well-video-container,
    .well-preview-image {
      width: $well-cards-video-size;
      height: $well-cards-video-size;
    }

    .well-preview-image {
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .well-card-details {
      margin-left: 8px;
      flex-grow: 1;
    }
  }

  &:hover {
    .well-card-content {
      background: $dark-2 !important;
      box-shadow: 0 0 1rem $shadow;
    }
  }
}

.compare-well-component {
  .well-card {
    box-shadow: none !important;

    .well-video-container,
    .well-preview-image {
      width: $well-compare-cards-video-width;
      height: $well-compare-cards-video-width;
    }

    .well-card-content {
      background: transparent !important;
      box-shadow: none !important;
    }

    .well-last-event {
      height: 2.7rem;
    }

    .well-status-controls {
      .btn {
        margin-top: 0.05rem;
        width: 1.7rem;
        height: 1.7rem;
      }
    }
  }
}
</style>
